class ProfilePicCreate
    constructor: (options) ->
        @.$el = null
        
        @.attrs = options?.attrs ? false
        @.badge = options?.badge ? false
        @.medium = options?.medium ? false
        @.pic = options?.pic ? false
        @.small = options?.small ? false
        @.tag = options?.tag ? 'div'
        @.onWhite = options?.onWhite ? false
        
        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'profile-pic', 'icon-user-before'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.small
            @.$el.classList.add 'profile-pic--small'
        if @.medium
            @.$el.classList.add 'profile-pic--medium'
        if @.onWhite
            @.$el.classList.add 'profile-pic--on-white'
        @.$el.innerHTML = "
            #{ if @.pic then "<div class='profile-pic__pic'></div>" else "" }
            #{ if @.badge then "<div class='profile-pic__badge icon-flag-before'></div>" else "" }
        "
        if @.pic
            @.$el.querySelector '.profile-pic__pic'
                .appendChild window.CreateImage {
                    lazyLoad: false
                    src: @.pic
                }
        return

window.CreateProfilePic = (options) ->
    return new ProfilePicCreate options